<template>
  <div class="print-cycle">
    <Card
      class="print-cycle__card mb-3"
      data-testid="print_relate"
      :title="relateTitle"
    >
      <template slot="content">
        <EvidenceSection
          fontSize="11"
          imageTestId="relate_photo"
          imageHeight="200"
          :mediaObject="relatePhoto"
          :questions="[
            {
              text: problemQuestion,
              answer: problemAnswer,
              tid: 'problem_question',
            },
            {
              text: ideaQuestion,
              answer: ideaAnswer,
              tid: 'idea_question',
            },
            {
              text: expectedResultQuestion,
              answer: expectedResultAnswer,
              tid: 'expected_question',
            },
          ]"
        />
      </template>
    </Card>
    <Card
      class="print-cycle__card mb-3"
      data-testid="print_experiment"
      :title="experimentTitle"
    >
      <template slot="content">
        <EvidenceSection
          fontSize="11"
          imageTestId="experiment_photo"
          :mediaObject="experimentPhoto"
          :questions="[
            {
              text: experimentResultQuestion,
              answer: experimentResultAnswer,
              tid: 'experiment_question',
            },
          ]"
        />
      </template>
    </Card>
    <Card
      class="print-cycle__card"
      data-testid="print_expand"
      :title="expandTitle"
    >
      <template slot="content">
        <EvidenceSection
          fontSize="11"
          imageTestId="expand_photo"
          :mediaObject="expandPhoto"
          :questions="[
            {
              text: expandQuestion,
              answer: expandAnswer,
              tid: 'expand_question',
            },
          ]"
        />
      </template>
    </Card>
  </div>
</template>

<script>
import Card from '@/components/RevPrint/Card'
import EvidenceSection from '@/components/RevPrint/EvidenceSection'

export default {
  name: 'PrintCycleSteps',
  components: {
    Card,
    EvidenceSection,
  },
  props: {
    relateTitle: {
      type: String,
      required: true,
    },
    relatePhoto: {
      type: Object,
      required: false,
    },
    problemQuestion: {
      type: String,
      required: true,
    },
    problemAnswer: {
      type: String,
      required: true,
    },
    ideaQuestion: {
      type: String,
      required: true,
    },
    ideaAnswer: {
      type: String,
      required: true,
    },
    expectedResultQuestion: {
      type: String,
      required: true,
    },
    expectedResultAnswer: {
      type: String,
      required: true,
    },
    experimentTitle: {
      type: String,
      required: true,
    },
    experimentPhoto: {
      type: Object,
      required: false,
    },
    experimentResultQuestion: {
      type: String,
      required: true,
    },
    experimentResultAnswer: {
      type: String,
      required: true,
    },
    expandTitle: {
      type: String,
      required: true,
    },
    expandPhoto: {
      type: Object,
      required: false,
    },
    expandQuestion: {
      type: String,
      required: true,
    },
    expandAnswer: {
      type: String,
      required: true,
    },
  },
}
</script>
<style lang="scss" scoped>
.print-cycle {
  box-sizing: border-box;
  display: block;
  &__card {
    height: 100%;
  }
}
</style>
